import { Component, Input, OnInit } from '@angular/core';
import { DataCardI } from 'src/app/core/interfaces/card.interface';

@Component({
  selector: 'app-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss'],
})
export class DataCardComponent implements OnInit {
  @Input() config: DataCardI;
  constructor() {}

  ngOnInit() {}
}
